import React from "react";

import { Stack, Typography, TypographyVariant } from "@mui/material";
import { Info } from "@mui/icons-material";

import { HelpBox } from "@/components/atoms";

type HelpTextProps = {
  text: string;
  subtext?: string;
  helpText: string;
  variant?: TypographyVariant;
  maxWidth?: number;
  whiteSpace?: string;
};

const HelpText: React.FC<HelpTextProps> = ({
  text,
  subtext,
  helpText,
  variant = "body1",
  maxWidth = 200,
  whiteSpace = "normal"
}) => {
  return (
    <Stack>
      <Stack direction="row" spacing={1} alignItems="center">
          <Typography variant={variant}>{text}</Typography>
        <HelpBox title={helpText} placement="right" maxWidth={maxWidth} whiteSpace={whiteSpace}>
          <Info fontSize="small" color="info" />
        </HelpBox>
      </Stack>
      {subtext && (
        <Typography variant="caption" color="textSecondary">{subtext}</Typography>
      )}
    </Stack>
  );
};

export default HelpText;
